<template>
  <div class="no-results-suggestions">
    <div class="h3 mb-4 text-left">Oops! Non abbiamo trovato risultati.</div>
    <date-suggestions />
    <flights-suggestions />
  </div>
</template>

<script>
  import DateSuggestions from './date-suggestions.vue';
  import FlightsSuggestions from './flights-suggestions.vue';

  export default {
    name: 'no-results-suggestions',
    components: {
      'date-suggestions': DateSuggestions,
      'flights-suggestions': FlightsSuggestions,
    },
  };
</script>

<style lang="scss">
  .no-results-suggestions {
    text-align: center;
    margin-bottom: $grid-gutter-width;
    .panel {
      margin-bottom: $grid-gutter-width !important;
    }
  }
</style>
